import {observable, action, computed} from 'mobx';
import BankRuptcyService from '../../services/BankRuptcyService';
import AssetInstitutionService from '../../services/AssetInstitutionService';
import React from "react";
import {objDeepCopy, isEmpty, BUSINESS_INFO} from '../../utils/tool';

class AssetPromotionInstitution {
  condition = {};
  @observable promotionAuctionList = []; // 推介拍品信息
  @observable promotionPageNo = 1; // 推介拍品分页
  @observable promotionListHasMore = true; // 推介拍品列表加载
  @observable realTimeData = {};
  @observable vendorId = ''; // 商家Id
  @observable auctionType = ''; // 推介类型 4-资产推介 5-破产推介 2-海关
  @observable publishSource = ''; // 业务线参数
  @observable topIdList = ''; // 置顶Id列表
  @observable idType = 0; //
  shopDisplay = 0; // 是否展示隐藏推介
  belongOrgDisplay = 0 // 是否展示海关隐藏推介
  @observable keyWord = '' // 商品搜索关键词

  // 缓存数据初始化
  // 缓存数据来自 滚动事件 滚动高度 筛选条件 数据列表
  @action.bound
  promotionInitStore(allStatus) {
    for (let key in allStatus) {
      this[key] = allStatus[key];
    }
  }
  @action.bound
  changeKeyWord(val){
    this.keyWord = val
  }
  @action.bound
  saveCurrData(name, data) {
    this[name] = objDeepCopy(data);
  }

  @action.bound
  addCondition(condition, isUserFilterEvent) {
    if (isUserFilterEvent) {
      // 如果是用户操作的筛选信息变更，需要清空置顶ID
      this.condition.topIdList = ''
    }
    for (let key in condition) {
      if (condition[key] == 'none') {
        delete this.condition[key];
        delete condition[key];
      }
    }

    this.resetAuctionList();
    this.condition = Object.assign(this.condition, condition);
    this.getPromotionAuctionList();
  }

  @action.bound
  resetCondition() {
    this.condition = {};
  }

  @action.bound
  resetAuctionList() {
    this.promotionAuctionList = []; // 清空推介拍品信息
    this.promotionPageNo = 1; // 拍品分页
    this.promotionListHasMore = true; // 拍品列表加载
    this.realTimeData = {};
  }

  @action.bound
  getSelectionParams() {
    let promotionParams = {
      venderId: this.vendorId,
      page: this.promotionPageNo,
      pageSize: 10,
      auctionType: this.auctionType,
      topIdList: this.topIdList,
    };

    if(this.publishSource == BUSINESS_INFO.HAIGUANANDZF.code){ //海关政府
      if (this.idType === 1) {
        promotionParams.venderId = this.vendorId
        promotionParams.belongOrgIdList = ''
      } else if (this.idType === 2) {
        promotionParams.belongOrgIdList = this.vendorId
        promotionParams.venderId = ''
      }
    }

    if (this.shopDisplay) {
      promotionParams.shopDisplay = this.shopDisplay;
    }
    if (this.belongOrgDisplay) {
      promotionParams.belongOrgDisplay = this.belongOrgDisplay;
    }

    if (isEmpty(this.condition)) {
      promotionParams = Object.assign(promotionParams);
    } else {
      promotionParams = Object.assign(promotionParams, this.condition);
    }
    promotionParams.keyWord = this.keyWord.trim();
    return promotionParams
  }

  @action.bound
  getPromotionAuctionList() {
    const promotionParams = this.getSelectionParams()
    // 推介
    return AssetInstitutionService.getPromotionAuctionList(promotionParams).then(
      res => {
        let promotionAuctionList = [];
        if (res && res.data && res.data.data && res.data.data.length) {
          promotionAuctionList = res.data.data;
          this.promotionAuctionList.push(...promotionAuctionList);
          if (promotionAuctionList.length < 10) {
            this.promotionListHasMore = false;
          }
          this.promotionPageNo += 1;
        } else {
          this.promotionListHasMore = false;
        }
        return Promise.resolve();
      }
    )

  }

  setAssetPromotionData = () => {
    sessionStorage.setItem('assetPromotionIndex', JSON.stringify({
      promotionPageNo: this.promotionPageNo,
      promotionListHasMore: this.promotionListHasMore,
      promotionAuctionList: this.promotionAuctionList,
      condition: this.condition,
      realTimeData: this.realTimeData,
      SortItem: this.SortItem,
      LocationItem: this.LocationItem,
      MoreItem: this.MoreItem,
      currFilterItems: this.currFilterItems,
    }))
  }
}

let assetPromotionInstitution = new AssetPromotionInstitution();

export default assetPromotionInstitution;
